import { Icon, Text, VStack } from '@chakra-ui/react';
import { FaWeight } from 'react-icons/fa';

import { JournalEntryCard } from '../JournalEntryCard/JournalEntryCard';
import { WeightJournalEntry } from '../types';

export interface WeightEntryCardProps {
  entry: WeightJournalEntry;
}

/**
 * Displays a weight journal entry with value, unit, and comments.
 */
export const WeightEntryCard: React.FC<WeightEntryCardProps> = ({ entry }) => {
  const hasWeight = entry.value !== null && entry.value !== undefined;

  return (
    <JournalEntryCard
      entryId={entry.id}
      icon={<Icon as={FaWeight} color="purple.500" boxSize={5} />}
      title={
        <Text fontSize="sm" fontWeight={600} color="text.default">
          Weight
        </Text>
      }
      time={entry.createdAt}
      timezone={entry.timezone}
      comments={entry.comments}
    >
      {({ isExpanded: expanded }) => (
        <VStack align="stretch" spacing={2}>
          {/* Weight Value (always visible) */}
          {hasWeight && (
            <Text fontSize="lg" fontWeight={600} color="purple.600">
              {entry.value} {entry.unit}
            </Text>
          )}

          {/* Description */}
          {expanded && entry.description && (
            <Text fontSize="sm" color="text.default">
              {entry.description}
            </Text>
          )}
        </VStack>
      )}
    </JournalEntryCard>
  );
};

WeightEntryCard.displayName = 'WeightEntryCard';
